<template>
  <div v-if="isOpen">
    <div class="filter-wrapper" @click="closeBlock"></div>

    <div class="filter-block" :class="{ active: localSelected }">



      <button @click="localSelected = !localSelected">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1226_1280)">
            <path
              d="M11.3335 5.33392H4.66683V4.66725C4.66662 3.92818 4.91205 3.21001 5.36451 2.62563C5.81697 2.04125 6.45081 1.62382 7.16638 1.43895C7.88195 1.25409 8.63867 1.31228 9.31757 1.60437C9.99646 1.89647 10.559 2.4059 10.9168 3.05258C10.9593 3.12914 11.0165 3.19658 11.0851 3.25105C11.1536 3.30552 11.2323 3.34594 11.3165 3.37003C11.4006 3.39411 11.4888 3.40137 11.5758 3.3914C11.6628 3.38143 11.7469 3.35442 11.8235 3.31192C11.9001 3.26941 11.9675 3.21224 12.022 3.14367C12.0764 3.07511 12.1169 2.99648 12.1409 2.91229C12.165 2.8281 12.1723 2.73999 12.1623 2.65299C12.1523 2.56599 12.1253 2.48181 12.0828 2.40525C11.5817 1.50012 10.794 0.787194 9.84352 0.378524C8.89306 -0.0301467 7.83374 -0.111385 6.83208 0.147579C5.83041 0.406542 4.94321 0.991024 4.30991 1.80915C3.67662 2.62727 3.33315 3.63265 3.3335 4.66725V5.61658C2.73974 5.87572 2.23436 6.30226 1.87916 6.84406C1.52397 7.38585 1.33435 8.0194 1.3335 8.66725V12.6672C1.33455 13.551 1.68608 14.3982 2.31098 15.0231C2.93587 15.648 3.7831 15.9995 4.66683 16.0006H11.3335C12.2172 15.9995 13.0645 15.648 13.6894 15.0231C14.3142 14.3982 14.6658 13.551 14.6668 12.6672V8.66725C14.6658 7.78352 14.3142 6.93629 13.6894 6.3114C13.0645 5.6865 12.2172 5.33497 11.3335 5.33392V5.33392ZM13.3335 12.6672C13.3335 13.1977 13.1228 13.7064 12.7477 14.0815C12.3726 14.4565 11.8639 14.6672 11.3335 14.6672H4.66683C4.1364 14.6672 3.62769 14.4565 3.25262 14.0815C2.87754 13.7064 2.66683 13.1977 2.66683 12.6672V8.66725C2.66683 8.13682 2.87754 7.62811 3.25262 7.25303C3.62769 6.87796 4.1364 6.66725 4.66683 6.66725H11.3335C11.8639 6.66725 12.3726 6.87796 12.7477 7.25303C13.1228 7.62811 13.3335 8.13682 13.3335 8.66725V12.6672Z"
              fill="#374957" />
            <path
              d="M8.00017 9.33398C7.82335 9.33398 7.65378 9.40422 7.52876 9.52925C7.40373 9.65427 7.3335 9.82384 7.3335 10.0006V11.334C7.3335 11.5108 7.40373 11.6804 7.52876 11.8054C7.65378 11.9304 7.82335 12.0006 8.00017 12.0006C8.17698 12.0006 8.34655 11.9304 8.47157 11.8054C8.5966 11.6804 8.66684 11.5108 8.66684 11.334V10.0006C8.66684 9.82384 8.5966 9.65427 8.47157 9.52925C8.34655 9.40422 8.17698 9.33398 8.00017 9.33398Z"
              fill="#374957" />
          </g>
          <defs>
            <clipPath id="clip0_1226_1280">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>

        {{ 'Show all blocked' | translate }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'filter-by-block',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: ['isOpen', 'selected', 'close'],
  data() {
    return {
      localSelected: false,
    }
  },
  methods: {
    closeBlock() {
      this.$emit('close')
    }
  },
  watch: {
    localSelected: {
      handler(value) {
        this.$emit('change', value)
      },

      deep: true,
    }
  },
  computed: {
    // renderedList() {
    //   return this.filterList.filter(i => i.name.toLowerCase().includes(this.searchInputValue.toLowerCase()))
    // },

    monthsList() {
      return [
        { value: '01', name: 'January' },
        { value: '02', name: 'February' },
        { value: '03', name: 'March' },
        { value: '04', name: 'April' },
        { value: '05', name: 'May' },
        { value: '06', name: 'June' },
        { value: '07', name: 'July' },
        { value: '08', name: 'August' },
        { value: '09', name: 'September' },
        { value: '10', name: 'October' },
        { value: '11', name: 'November' },
        { value: '12', name: 'December' },
      ]
    },

    yearsList() {
      const yearList = []

      for (let year = 2017; year <= new Date().getFullYear(); year++) {
        yearList.push(year)
      }

      return yearList
    }
  }
}
</script>

<style lang="scss">
.filter-wrapper {
  position: fixed;

  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  z-index: 4;
}

.filter-block {
  display: flex;
  position: absolute;

  top: 40px;
  right: 5px;

  padding: 10px;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);

  background-color: #fff;

  z-index: 5;

  justify-content: space-evenly;

  width: max-content;

  // height: 400px;

  & button {
    background-color: #fff;

    padding: 4px 8px;

    border-color: #B7AFBF;
    border-radius: 8px;
  }

  &.active button {
    border-color: #2795E2;
  }
}

// .search-input-wrapper {
//   position: relative;

//   .search-input-logo {
//     position: absolute;

//     top: 5px;
//     left: 10px;
//   }

//   .search-input {
//     width: 300px;
//     padding: 5px 5px 5px 40px;
//     align-items: center;

//     border-radius: 8px;
//     border: 1px solid #B7AFBF;
//   }
// }</style>